// extracted by mini-css-extract-plugin
module.exports = {"caseFolderContainer":"styles_caseFolderContainer__3piIp","labelRow":"styles_labelRow__2TcMf","office":"styles_office__1GkI4"};